export default "__VITE_ASSET__B8MP7fsC__"